import { useMsal } from '@azure/msal-react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiFetch, type JobDetail, type JobInput, type JobSummary } from './client';

export function useJobs() {
  const { instance } = useMsal();
  return useQuery({
    queryKey: ['jobs'],
    queryFn: () => apiFetch<JobSummary[]>(instance, '/api/jobs'),
  });
}

export function useJob(id: string | undefined) {
  const { instance } = useMsal();
  return useQuery({
    queryKey: ['jobs', id],
    queryFn: () => apiFetch<JobDetail>(instance, `/api/jobs/${id}`),
    enabled: Boolean(id),
  });
}

export function useCreateJob() {
  const { instance } = useMsal();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: JobInput) =>
      apiFetch<JobSummary>(instance, '/api/jobs', {
        method: 'POST',
        body: JSON.stringify(input),
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['jobs'] }),
  });
}

export function useUpdateJob(id: string) {
  const { instance } = useMsal();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: Partial<JobInput>) =>
      apiFetch<JobDetail>(instance, `/api/jobs/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(input),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['jobs'] });
      qc.invalidateQueries({ queryKey: ['jobs', id] });
    },
  });
}
